import React, { useEffect, useState } from "react";
import {
  FiUser,
  FiMail,
  FiPhone,
  FiShield,
  FiEdit2,
  FiArrowLeft,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";

import EditProfileModal from "./EditProfileModal";
import "./profile.css";

const ProfileModal = () => {
  const navigate = useNavigate();

  const [profile, setProfile] = useState({});
  const [showEdit, setShowEdit] = useState(false);

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user") || "{}");
    setProfile(user);
  }, []);

  const roleName = (role) => {
    switch (role) {
      case "admin":
        return "Administrator";
      case "tstaff":
        return "Teacher";
      case "mstaff":
        return "Teacher";
      case "tmstaff":
        return "Teaching & Management";
      default:
        return role || "-";
    }
  };

  return (
    <>
      <div className="profilePage">

        {/* Header */}

        {/* <div className="profilePageTop">

          <button
            className="backBtn"
            onClick={() => navigate(-1)}
          >
            <FiArrowLeft />
            Back
          </button>

          <h2>My Profile</h2>

        </div> */}

        <div className="profileModal">

          {/* Header */}

          <div className="profileHeader">

  {/* <div className="profileAvatar">
    <img
      src={`https://ui-avatars.com/api/?background=6C63FF&color=fff&size=256&name=${encodeURIComponent(
        profile.name || "User"
      )}`}
      alt={profile.name}
    />
  </div> */}

  <div className="profileContent">

    <div className="profileTopRow">

      <div>

        <h2>{profile.name}</h2>

        <span className="roleBadge">
          {roleName(profile.role)}
        </span>

      </div>

      <button
        className="editHeaderBtn"
        onClick={() => setShowEdit(true)}
      >
        <FiEdit2 />
        Edit Profile
      </button>

    </div>

    <div className="profileContact">

      <p>
        <FiMail />
        {profile.email}
      </p>

      <p>
        <FiPhone />
        {profile.phone || "-"}
      </p>

    </div>

  </div>

</div>

          {/* Information */}

          <div className="profileBody">

            <h3 className="sectionTitle">
              Profile Information
            </h3>

            <div className="infoRow">
              <div className="left">
                <FiUser />
                <span>Name</span>
              </div>

              <div className="right">
                {profile.name || "-"}
              </div>
            </div>

            <div className="infoRow">
              <div className="left">
                <FiMail />
                <span>Email</span>
              </div>

              <div className="right">
                {profile.email || "-"}
              </div>
            </div>

            <div className="infoRow">
              <div className="left">
                <FiPhone />
                <span>Phone</span>
              </div>

              <div className="right">
                {profile.phone || "-"}
              </div>
            </div>

            <div className="infoRow">
              <div className="left">
                <FiShield />
                <span>Role</span>
              </div>

              <div className="right">
                {roleName(profile.role)}
              </div>
            </div>

            <div className="infoRow">
              <div className="left">
                <span>Status</span>
              </div>

              <div className="right">
                <span
                  className={`statusBadge ${
                    profile.status === "active"
                      ? "active"
                      : "inactive"
                  }`}
                >
                  {profile.status || "Active"}
                </span>
              </div>
            </div>

          </div>

          

        </div>

      </div>

      {showEdit && (
        <EditProfileModal
          profile={profile}
          setProfile={setProfile}
          onClose={() => setShowEdit(false)}
        />
      )}
    </>
  );
};

export default ProfileModal;